import { useCallback } from 'react'

import useApiPost from 'Pods/Shared/Hooks/useApiPost'
import useSentry from 'Pods/Shared/Hooks/useSentry'

export const usePrintModels = () => {
  const { postData } = useApiPost()
  const { captureException } = useSentry()

  const trackFeaturedDesigner = useCallback(
    (designerId) => {
      return new Promise((resolve, reject) => {
        postData({
          path: `/api/internal/featured_designers/${designerId}/track`,
          data: {},
          onSuccess: (response) => resolve(response),
          onError: (error) => {
            captureException(error, { extra: { message: 'Error tracking featured designer', designerId } })
            reject(error)
          },
        })
      })
    },
    [postData, captureException]
  )

  return {
    trackFeaturedDesigner,
  }
}
